<template>
  <q-card v-for="o in offices" :key="o.id" :id="o.id"
           @click="select(o.id)"
           bordered
           v-ripple
           
          class="q-pa-xs col-4 clickable q-mb-md"
           >
           <q-card-section>
             <div class="text-h5 text-center">{{ o.office_name }}</div>
             <div class="">
               {{ o.office_address_street }}
             </div>

             <div class="row">
               <span class="col-3">{{ o.office_address_zipcode }}</span>
               <span class="col-4">{{ o.office_address_city }}</span>
             </div>
           </q-card-section>
  </q-card>
</template>
<script>
import office from "@/services/office";
import _ from "lodash";

export default {
  name: "OfficeSet",

  data: () => ({
    offices: [],
    error: {
      active: false,
      message: null
    }
  }),
  props: {
    autoSelectOffice: Boolean
  },
  created: function() {
    const self = this;
    office
      .offices()
      .then(function(response) {
        self.offices = _.orderBy(response.data, o => {
          return o.id;
        });
      })
      .catch(function(error) {
        if (error.response) {
          self.message = error.response.data;
          self.active = true;
        }
      });
  },
  mounted: function() {
    //const self = this;
    //setTimeout(() => {
    //  if (self.offices.length == 1 && self.autoSelectOffice) {
    //    document.location.replace("/");
    //  }
    //}, 1500);
  },
  methods: {
    select: function(office_id) {
      const self = this;
      office
        .set(office_id)
        .then(function() {
          document.location.replace("/");
        })
        .catch(function(error) {
          if (error.response) {
            self.message = error.response.data;
            self.active = true;
          }
        });
    }
  }
};
</script>

<style lang="scss">
.clickable {
  cursor: pointer;
}
</style>
